import { Control } from "../../control";
import { automountComments } from "../../mounts/comments";

export class ArticlesDocsController extends Control {
  constructor(el, options) {
    super(el, options);
    automountComments(this._app);
  }
}
